import React from 'react';
import { createRoot } from 'react-dom/client';
import './styles/styles.css'; // global tokens + font loading (must load before components)
import { App } from './App';
import { captureFirstTouch } from './lib/attribution';
import { installNavGuard } from './lib/navGuard';

// Before routing: a Redirect (e.g. an unknown path → "/") would drop the landing URL's utm_*.
captureFirstTouch(window.location.search);
// Back/Forward interception for screens that hold navigation (Buddy Call). Before render.
installNavGuard();

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
